<template>
  <div>
    <b-card
      no-body
      class="mb-0"
    >
      <div class="m-2 mt-3">
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Afficher</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="pageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>entrées</label>
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-input-group size="sm">
                <b-form-input
                  id="filterInput"
                  v-model="filterInput"
                  type="search"
                  placeholder="Saisissez votre recherche"
                  @keyup.enter="applyFilter"
                />
                <b-input-group-append>
                  <b-button
                    @click="applyFilter"
                  >
                    Rechercher
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </div>
          </b-col>
          <b-col
            cols="12"
            md="6"
          />

        </b-row>

        <!-- Tableau -->
        <b-row>
          <b-col cols="12">
            <b-table
              id="datatables"
              class="mt-4 mb-4 data-list-view"
              :items="Docs"
              :fields="fields"
              stacked="md"
              :per-page="perPage"
              :current-page="currentPage"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
              :filter="filter"
              :filter-included-fields="filterOn"
              selectable
              select-mode="multiple"
              striped
              small
              @filtered="onFiltered"
              @row-clicked="item=>$set(item, '_showDetails', !item._showDetails)"
            >

              <template #cell(attachments)="data">
                <img :src=data.value height="90" width="auto"/>
              </template>
              <!-- Column: Actions -->
              <template #cell(actions)="data">
                <b-button
                  v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                  :to="{name: 'viewclient', params: { id: data.item.key }}"
                  variant="flat-success"
                  class="btn-icon rounded-circle"
                >
                  <feather-icon icon="PlusCircleIcon" />
                </b-button>
              </template>
            </b-table>
          </b-col>
        </b-row>
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          />
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BInputGroup,
  BInputGroupAppend,
  BButton,
  BTable,
  BLink,
  BDropdown,
  BDropdownItem,
  BPagination,
  BFormGroup,
  BFormCheckbox,
  BFormCheckboxGroup,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import PouchDB from 'pouchdb'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    BButton,
    BTable,
    BLink,
    BDropdown,
    BDropdownItem,
    BPagination,
    BFormGroup,
    BFormCheckbox,
    BFormCheckboxGroup,
    vSelect,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      fields: [
        // {key: 'show_details', label: '', thStyle: { width: '10px'}},
        { key: 'actions', label: '', thStyle: { width: '10px' } },
        { key: 'attachments', label: 'attachments', thStyle: { width: '160px' }, class: 'attachments' },
        { key: 'key', label: 'ID', sortable: true },
      ],
      Docs: [],
      isLoading: true,
      drawer: true,
      perPage: 50,
      currentPage: 1,
      totalRows: 1,
      currentPage: 1,
      filterInput: '',
      pageOptions: [10, 25, 50, 100],
      filter: null,
      outlined: true,
      filterOn: ['ref'],
      sortBy: 'ref',
      sortDirection: 'asc',
      sortDesc: false,
    }
  },
  computed: {
    /**
      * Total no. of records
      */
    rows() {
      return this.items.length
    },
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
  },
  watch: {},
  created() {
    this.localDB = new PouchDB(`${process.env.VUE_APP_LOCAL_DB_URL}`)
    this.remoteDB = new PouchDB(`${process.env.VUE_APP_REMOTE_DB_URL}`)
    this.localDB.sync(this.remoteDB).on('complete', complete => {
      // Création d'un index de recherche
      this.localDB.createIndex({
        index: { fields: ['type'] },
      })

      // // Lecture des document sur l'index de recherhe type=Images
      this.localDB.find({ selector: { type: 'images' } }, this.setImages)

      // this.localDB.allDocs({include_docs: true}, function(err, doc) {
      //   if (err) {
      //       return console.log('err',err);
      //   } else {
      //       console.log ('doc', doc.rows);
      //       for (let i = 0; i < doc.docs.length; i++) {
      //         this.Docs.push({
      //           key: doc.docs[i]._id,
      //           ref: doc.docs[i].type,
      //           name: doc.docs[i].name,
      //         })
      //       }
      //       this.totalRows = this.Docs.length
      //   }
      // })


    }).on('error', err => {
      // boo, we hit an error!
      alert('error')
    })
  },
  mounted() {},
  customButtons: {
    default: true,
  },
  methods: {
    setImages(err, doc) {
      if (err) {
        console.log('err', err)
      }
      console.log('doc', doc)
      for (let i = 0; i < doc.docs.length; i++) {

        this.localDB.getAttachment(doc.docs[i]._id, Object.keys(doc.docs[i]._attachments)[0]).then((blobOrBuffer) => {
          console.log(URL.createObjectURL(blobOrBuffer))
          console.log('attached', Object.keys(doc.docs[i]._attachments))

          this.Docs.push({
            key: doc.docs[i]._id,
            ref: doc.docs[i].type,
            attachments: URL.createObjectURL(blobOrBuffer),
          })

        }).catch(function (err) {
          console.log(err);
        });



      }
      this.totalRows = this.Docs.length
    },
    fetchToDos() {
      this.localDB.allDocs({ include_docs: true, descending: true }, this.setToDos)
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    applyFilter() {
      this.filter = this.filterInput
    },
  },
}
</script>

<style>
    .btn-primary {
        margin-right: 12px;
    }
    .per-page-selector {
      width: 90px;
    }
    .btNopadding button {
      padding: 0;
    }
    @media (max-width: 767.98px) {
      .table.b-table.b-table-stacked-md > tbody > tr > [data-label]::before {
        text-align: left;
      }
    }
</style>

<style lang="scss">
  @import '~@core/scss/vue/libs/vue-select.scss'; 
</style>
